import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineComponent } from './timeline.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CorePipesModule } from '@core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { CoreDirectivesModule } from '@core/directives/directives';
import { IconsModule } from 'app/components/icons';

@NgModule({
  declarations: [TimelineComponent],
  imports: [
    CommonModule,
    CorePipesModule,
    TranslateModule,
    NgbModule,
    CoreDirectivesModule,
    IconsModule
  ],
  exports: [TimelineComponent]
})
export class TimeLineModule {}
